import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Box,
  IconButton,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import DataTable from "react-data-table-component";
import { LoadingContext } from "../../../../context/spinnerContext";
import { Close } from "@material-ui/icons";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

const columns = [
  {
    name: "Resource",
    selector: "name",
  },
  {
    name: "Quantity",
    selector: "quantity",
  },
];

const StartExecution = (props) => {
  const { setIsLoading } = useContext(LoadingContext);
  const [loading, setLoading] = useState(false);
  const [executionData, setExecutionData] = useState([]);
  const [region, setRegion] = useState("");
  const [selectValue, setSelectValue] = useState(null);
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [dailogHeader, setDailogHeader] = useState("");
  const [dailogBody, setDailogBody] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [modelOpts, setModelOptions] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    const response = await axios.get(
      `/cm_open_loop/resources/tobe/created-by?topology_id=${props.data.job_id}`
    );
    setRegion(response.data.resources[0].region);
    setExecutionData(response.data.resources[0].resources);
    setLoading(false);
  };

  const handleSelectChange = (event) => {
    const newSelectValue = event.target.value;
    setSelectValue(newSelectValue);
  };

  const setModelNameValue = () => {
    const modelOptsExceptGenric = props.modelOptions.filter((item) => item.value !== 'Generic')
    const opts = [{
      key: 'select',
      value: '--Select--'
    }, ...modelOptsExceptGenric]
    setModelOptions(opts);
    setSelectValue('--Select--');
  };

  useEffect(() => {
    fetchData();
    setModelNameValue();
  }, []);

  const onClickStartExecution = () => {
    // props.selectValue !== selectValue -> condition if selected model and created model is different
    if (false) {
      setDailogHeader("Confirmation");
      setDailogBody(
        "Selected model name is different than user group model. Still want to continue ?"
      );
      setDialogOpen(false);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    if (username.trim() === "") {
      setError("Username is required");
      return;
    }
    setError("");
    try {
      setIsLoading(true);
      await axios.post("/cm_open_loop/start/virtual-validation", {
        job_uuid: props.data.job_id,
        user: username.trim(),
        cad_topoloogy_id: props.data.job_id,
        cad_topology_uuid: props.data.job_id,
        model_name: selectValue,
      });
      setDailogHeader("Execution Started");
      setDailogBody("The execution has started successfully.");
      setDialogOpen(true);
    } catch (err) {
      setError("Failed to start execution");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    handleSubmit();
  };

  return (
    <div>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">Start Execution</Typography>
        <IconButton onClick={props.handleClose}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
      {!loading && (
        <div style={{ marginTop: "20px" }}>
          <Typography variant="h6">Resources in {region}</Typography>
          <Grid container spacing={5} style={{ marginTop: "15px" }}>
            <Grid item xs={6}>
              <DataTable
                columns={columns}
                data={executionData}
                noDataComponent={"No Resources found for the current topology"}
                progressPending={loading}
                dense
                customStyles={customStyles}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography>
                Are you sure you want to execute this{" "}
                <strong>{props.data.topology_tag_name}</strong> topology?
              </Typography>
              {modelOpts && !!modelOpts.length && (
                <FormControl
                  variant="outlined"
                  style={{ minWidth: 200, marginTop: "1rem" }}
                >
                  <Select
                    value={selectValue}
                    onChange={handleSelectChange}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                    }}
                  >
                    {modelOpts.map((option) => (
                      <MenuItem key={option._id} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {selectValue && selectValue !== "--Select--" && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "#f9f9f9",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="body2">
                    {modelOpts.find((opt) => opt.value === selectValue).description ||
                      "No description available"}
                  </Typography>
                </div>
              )}
              <TextField
                style={{ marginTop: "10px" }}
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                margin="normal"
              />
              {error && <Alert severity="error">{error}</Alert>}
              <Typography variant="body2" color="textSecondary">
                Please enter your name to make an entry in the Ticketing system.
              </Typography>
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={onClickStartExecution}
              variant="contained"
              color="primary"
              style={{ background: selectValue === '--Select--' && '#b3b3b3', cursor: 'pointer' }}
              disabled={selectValue === '--Select--'}
            >
              Start Execution
            </Button>
          </div>
        </div>
      )}

      <Dialog
        open={dialogOpen}
        aria-labelledby="execution-started-dialog-title"
      >
        <DialogTitle id="execution-started-dialog-title">
          {dailogHeader}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{dailogBody}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {dailogHeader === "Confirmation" && (
            <Button onClick={handleDialogClose} color="primary">
              OK, Continue
            </Button>
          )}
          <Button
            onClick={() =>
              dailogHeader === "Confirmation"
                ? setDialogOpen(false)
                : props.setIsOpen()
            }
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StartExecution;
